import React from 'react'
import { PropsWithChildren } from 'react'
import { AppAuthContext } from '../constants'
import { AppAuthProviderProps } from '../types'

const AppAuthProviderView: React.FC<PropsWithChildren<AppAuthProviderProps>> = ({ children, contextValue }) => {
    return <AppAuthContext.Provider value={contextValue}>{contextValue.isAuthenticated && children}</AppAuthContext.Provider>
}
export default AppAuthProviderView
